import { CognitiveDomain } from "@/types/api";
import { stringEquals } from "@/utils/string-utils";

import { AccordionSection } from "./types";

export function hasCategory(
  category: string,
  accordionData: AccordionSection[],
  cognitiveDomains?: CognitiveDomain[]
): boolean {
  const section = accordionData.find((row) => stringEquals(row.title, category));
  if (!section) {
    return false;
  }

  return section.content.some((cogDomain) => !!cognitiveDomains?.includes(cogDomain));
}
